export default "__VITE_ASSET__bVy60QAZ__"